import { registerSectionComponent } from '../../../config/sectionRegistry';
import HowToHeroSection from './HowToHeroSection';
import HowToStepsSection from './HowToStepsSection';
import HowToStepsChaseTheAceSection from './HowToStepsChaseTheAceSection';
import HowToVideoSection from './HowToVideoSection';
import HowToGameRulesSection from './HowToGameRulesSection';
import HowToFaqTeaserSection from './HowToFaqTeaserSection';
import HowToCtaSection from './HowToCtaSection';

// Register all How-To-Play sections
registerSectionComponent('howto_hero', HowToHeroSection, {
  category: 'hero',
  label: 'How-To Hero',
  description: 'Hero section for How to Play page',
  supportedPages: ['how_to_play'],
});

registerSectionComponent('howto_steps', HowToStepsSection, {
  category: 'content',
  label: 'How-To Steps',
  description: 'Four-step quick guide cards',
  supportedPages: ['how_to_play'],
});

registerSectionComponent('howto_steps_chase_the_ace', HowToStepsChaseTheAceSection, {
  category: 'content',
  label: 'How-To Steps (Chase the Ace)',
  description: 'Four-step guide for Chase the Ace mechanics',
  supportedPages: ['how_to_play'],
});

registerSectionComponent('howto_video', HowToVideoSection, {
  category: 'content',
  label: 'How-To Detailed Instructions',
  description: 'Visual step-by-step guide with images',
  supportedPages: ['how_to_play'],
});

registerSectionComponent('howto_game_rules', HowToGameRulesSection, {
  category: 'content',
  label: 'Game Rules & Requirements',
  description: 'Important information and requirements',
  supportedPages: ['how_to_play'],
});

registerSectionComponent('howto_faq_teaser', HowToFaqTeaserSection, {
  category: 'content',
  label: 'FAQ Teaser',
  description: 'Preview of common FAQs with link to full page',
  supportedPages: ['how_to_play'],
});

registerSectionComponent('howto_cta', HowToCtaSection, {
  category: 'promo',
  label: 'How-To Call-to-Action',
  description: 'Final CTA to encourage sign-up',
  supportedPages: ['how_to_play'],
});

export {
  HowToHeroSection,
  HowToStepsSection,
  HowToStepsChaseTheAceSection,
  HowToVideoSection,
  HowToGameRulesSection,
  HowToFaqTeaserSection,
  HowToCtaSection,
};
